import { render } from "./CollectionsReport.vue.js?vue&type=template&id=085c00e9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionsReport.vue?vue&type=template&id=085c00e9"
import script from "./CollectionsReport.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionsReport.vue?vue&type=script&lang=js"
export * from "./CollectionsReport.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionsReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/CollectionsReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "085c00e9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('085c00e9', __exports__)) {
    api.reload('085c00e9', __exports__)
  }
  
  module.hot.accept("./CollectionsReport.vue.js?vue&type=template&id=085c00e9!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionsReport.vue?vue&type=template&id=085c00e9", () => {
    api.rerender('085c00e9', render)
  })

}


export default __exports__